module.exports = __webpack_public_path__ + "media/images/navbar_banner-afa5fdd09eed0832f40cd25a9be8743a.webp";